import { helper } from '@ember/component/helper';
import pluralize from 'cio/utils/pluralize';

export const SECONDS_IN_MINUTE = 60;
export const MINUTES_IN_HOUR = 60;
export const HOURS_IN_DAY = 24;

export function secondsToReadable([seconds], { minuteSuffix = 'minute', hourSuffix = 'hour', daySuffix = 'day' }) {
  let numberOfMinutes = seconds / SECONDS_IN_MINUTE;
  let numberOfHours = numberOfMinutes / MINUTES_IN_HOUR;
  let numberOfDays = numberOfHours / HOURS_IN_DAY;

  if (numberOfMinutes < 1) {
    return 'less than a minute';
  } else if (numberOfHours < 1) {
    return `${Math.round(numberOfMinutes)} ${pluralize(numberOfMinutes, minuteSuffix)}`;
  } else if (numberOfHours % HOURS_IN_DAY === 0) {
    return `${numberOfDays} ${pluralize(numberOfDays, daySuffix)}`;
  } else {
    return `${Math.round(numberOfHours)} ${pluralize(numberOfHours, hourSuffix)}`;
  }
}

export default helper(secondsToReadable);
